const TOKEN_KEY = 'report_management_token'
const USER_KEY = 'report_management_user'
const MENU_KEY = 'report_management_menu'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token) {
  localStorage.setItem(TOKEN_KEY, token || '')
}

export function removeToken () {
  localStorage.removeItem(TOKEN_KEY)
}

export function getUserInfo () {
  const value = localStorage.getItem(USER_KEY)
  if (!value) return null
  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

export function setUserInfo (userInfo) {
  localStorage.setItem(USER_KEY, JSON.stringify(userInfo || {}))
}

export function removeUserInfo () {
  localStorage.removeItem(USER_KEY)
}

export function getCachedMenu () {
  const value = localStorage.getItem(MENU_KEY)
  if (!value) return []
  try {
    return JSON.parse(value)
  } catch (error) {
    return []
  }
}

export function setCachedMenu (menu) {
  localStorage.setItem(MENU_KEY, JSON.stringify(menu || []))
}

export function removeCachedMenu () {
  localStorage.removeItem(MENU_KEY)
}

export function clearAuthStorage () {
  removeToken()
  removeUserInfo()
  removeCachedMenu()
}
